import * as actions from './actions';
import * as getters from './getters';
import { GET_MY_EVENTS, DELETE_AN_EVENT } from '../../mutation-types';


const mutations = {
  [GET_MY_EVENTS](state, payload) {
    state.myEvents = payload
  },
  [DELETE_AN_EVENT](state, payload) {
    state.selectedId = payload
  },
};

const state = {
  myEvents: [],
  selectedId: null,
  url: 'v1/reservation'
};

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};
